export default __webpack_public_path__ + "static/media/success-tick.e39fa5f5.png";